import React from 'react';

import { useDiscountWizardStateContext } from '../state';

import { FiltersAppliedButton } from './applied-filters';
import { useFilteredProducts } from './use-filtered-products';

export function FilteredProductCount({ requirement }: { requirement: number | 'reward' }) {
  const filteredProducts = useFilteredProducts({ requirement });
  const { setShowEligibleProductsModal, setEligibleProductsModalRequirement } = useDiscountWizardStateContext();
  const singularProduct = filteredProducts.length === 1;

  const onClick = () => {
    setShowEligibleProductsModal(true);
    setEligibleProductsModalRequirement(requirement);
  };

  return (
    <FiltersAppliedButton onClick={onClick}>
      {filteredProducts.length} {singularProduct ? 'product' : 'products'}
    </FiltersAppliedButton>
  );
}
